import cn from "classnames"

import { highProfileVulnerabilities } from "@/api/useIssue.demo"
import { Link, Text } from "@/atoms"
import { isHighProfileIssue } from "@/domain/issue"
import {
  DEFAULT_LONG_FORMAT,
  getDateFromSeconds,
  getDateInUserLocale
} from "@/helpers/date.helpers"
import { getDomainFromURL } from "@/helpers/url.helpers"
import { FireFilled } from "@/icons"
import { InformationPopover } from "@/molecules/InformationPopover"

import styles from "./HighProfileIcon.module.scss"

import type { HighProfileIconProps } from "./HighProfileIcon.types"

export const HighProfileIcon = (props: HighProfileIconProps) => {
  const { record, placement, className, t } = props

  const showForDemo =
    record.riskId === highProfileVulnerabilities[0].riskIds[0].id
  const highProfile = showForDemo
    ? highProfileVulnerabilities[0]
    : isHighProfileIssue(record) && record.highProfile?.[0]

  if (!highProfile) return null

  return (
    <InformationPopover.Popover
      destroyOnHidden
      placement={placement}
      content={
        <InformationPopover.CommonTemplate title="High Profile Issue">
          <Text
            className="sm-text-ks capitalize-text-ks"
            type="secondary"
          >{`${t("general.update")}: ${getDateInUserLocale(getDateFromSeconds(highProfile.updatedAt), DEFAULT_LONG_FORMAT)}`}</Text>
          {highProfile.references && (
            <ul className={styles.list}>
              {highProfile.references.map((reference, index) => (
                <li key={index}>
                  <Link href={reference.url} target="_blank" type="link-hover">
                    {getDomainFromURL(reference.url) || reference.label}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </InformationPopover.CommonTemplate>
      }
    >
      <FireFilled className={cn(styles.icon, className)} />
    </InformationPopover.Popover>
  )
}
